import React, { useEffect, useState } from "react";

const Card = ({ color, title, value, valueText, extra = [], sections = [], icon }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const normalizedTitle = String(title || "").toLowerCase();

  let valueColor = "#222";
  if (normalizedTitle.includes("foyda")) valueColor = "#00b894";
  if (normalizedTitle.includes("xarajat")) valueColor = "#d63031";
  if (normalizedTitle.includes("savdo")) valueColor = "#0984e3";

  useEffect(() => {
    if (!Number.isFinite(Number(value))) {
      setDisplayValue(0);
      return;
    }

    const duration = 1000;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const newValue = Math.floor(progress * Number(value));
      setDisplayValue(newValue);
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [value]);

  return (
    <div
      style={{
        background: `linear-gradient(145deg, #ffffff, #f7f8fa)`,
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.07)",
        padding: "20px 18px",
        borderTop: `4px solid ${color}`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all 0.25s ease",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-4px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0px)")}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4 style={{ margin: 0, fontSize: "13px", color: "#444", fontWeight: 600 }}>
          {title}
        </h4>
        {icon && (
          <div
            style={{
              backgroundColor: color,
              color: "#fff",
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
            }}
          >
            {icon}
          </div>
        )}
      </div>

      <p
        style={{
          fontSize: "20px",
          fontWeight: 700,
          margin: "10px 0 4px",
          color: valueColor,
          letterSpacing: "0.5px",
          transition: "color 0.3s ease",
        }}
      >
        {valueText || (
          <>
            {displayValue.toLocaleString("uz-UZ")}
            <span style={{ fontSize: "12px", color: "#666" }}> so'm</span>
          </>
        )}
      </p>

      {sections.length > 0 && (
        <div
          style={{
            fontSize: "12px",
            color: "#555",
            marginTop: "8px",
            borderTop: "1px dashed #ddd",
            paddingTop: "6px",
          }}
        >
          {sections.map((section, si) => (
            <div key={si} style={{ marginTop: si === 0 ? 0 : "8px" }}>
              {section.title && (
                <p
                  style={{
                    margin: "4px 0 2px",
                    fontSize: "10px",
                    fontWeight: 700,
                    color: "#888",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {section.title}
                </p>
              )}
              {(section.items || []).map((it, i) => (
                <p
                  key={i}
                  style={{
                    margin: "2px 0",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "8px",
                    fontWeight: it.emphasize ? 600 : 400,
                    color: it.emphasize ? "#222" : "#555",
                  }}
                >
                  <span>{it.label}</span>
                  <span>{it.value}</span>
                </p>
              ))}
            </div>
          ))}
        </div>
      )}

      {sections.length === 0 && extra.length > 0 && (
        <div
          style={{
            fontSize: "12px",
            color: "#555",
            marginTop: "8px",
            borderTop: "1px dashed #ddd",
            paddingTop: "6px",
          }}
        >
          {extra.map((e, i) => (
            <p key={i} style={{ margin: "2px 0" }}>
              {e}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default Card;
